import Splide from '@splidejs/splide';
// require('jqueryui');
import { send_getNearbyCamps } from './util/search_api';
import { init_instantBook } from './instantBook_integration';

import './campground_page';
import { reverseGeocode } from './util/user_api';
import { StopByStopTrip_autofill } from './util/autofill_scripts';

$(function() {
    let camp_splides:Array<Splide> = [];
    let campID:string = $("[campid]").attr('campid')

    send_getNearbyCamps(campID).then(nearbyCampsHTML => {
    $("#nearbyCampsDisp").html(nearbyCampsHTML);
    var elms = document.getElementsByClassName( 'campSplide' );
    for ( var i = 0; i < elms.length; i++ ) {
        let splide:Splide = new Splide( elms[i] as HTMLElement ).mount();
        camp_splides.push(splide);
    };
    camp_splides.forEach(el => {
        el.emit("resize");
    });
    });

    if (window.location.hash == "#instantBook") {
        $("#cgCardInstantBookButton").trigger("click");
    };


    init_instantBook(false);

    $(document).on("focus", ".stop-by-stop-input", function(event) {
        $("#stop-by-stop-autofill").show();
        let $autofill_results:JQuery<HTMLElement> = $("#stop-by-stop-autofill").find("#autofill_results");
            if (! $autofill_results.html().length) $("#user-locations-wrapper").show();
        else $autofill_results.removeClass("d-none");
        let linkedInputElement:JQuery<HTMLElement> = $(event.target);
        window.curAutofillInput = linkedInputElement as JQuery<HTMLInputElement>;

        let firstStopOffset = $("#from").offset().left;

        $autofill_results.parent().css("left", (linkedInputElement.offset().left - firstStopOffset));
        $autofill_results.parent().css("top", linkedInputElement.parent().position().top + linkedInputElement.outerHeight());
    });

    $(document).on("focusout", ".stop-by-stop-input", ()=>{$("#stop-by-stop-autofill:not(:hover)").hide();});

    let typingTimer: ReturnType<typeof setTimeout>;
    const doneTypingInterval = 250;
    $(document).on("keydown", ".stop-by-stop-input", (event: JQuery.KeyboardEventBase<any, any, any, any>) => {
        if (event.key == "Enter" || event.key == "Escape" || event.key == "Tab") {
            $("#stop-by-stop-autofill").hide();
        };
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function() {
            $(".stop-by-stop-input").off("keydown");

            StopByStopTrip_autofill(event);
        }.bind(this),doneTypingInterval);
    });

    $(document).on("click", "#useHome", function() {
        let address:string = $("#useHome").attr("data");
        window.curAutofillInput.val(address);
        $("#stop-by-stop-autofill").hide();
    });

    $(document).on("click", "#getLocation", ()=> {
        if (!navigator.geolocation) {
            console.error(`Your browser doesn't support Geolocation`);
        }else{
            navigator.geolocation.getCurrentPosition((position)=>{
                window.curAutofillInput.attr("query_type","poi");
                window.curAutofillInput.attr("query_val", `${position.coords.latitude},${position.coords.longitude}`)


                reverseGeocode(position.coords.latitude, position.coords.longitude).then((address: any) => {
                    // $('#startLocation').val(address);
                    window.curAutofillInput.val(address);
                    $("#stop-by-stop-autofill").hide();
                }).catch(e => {
                    $("#exception_str").val(e.toString());
                    $("#errorModal").modal("show");
                });
            }), ()=>{
                console.error(`Failed to get Geolocation`);
            };
        }
    });

    $("#cgPage_tpSearch").on("submit", function() {
        let from:JQuery<HTMLInputElement> = $("#from");
        let to:JQuery<HTMLInputElement> = $("#to");
        let driveDist:number = 300;

        let from_query_type:string|undefined = from.attr("query_type");
        let from_query_val:string|undefined = from.attr("query_val");
        let from_text:string = encodeURIComponent(from.val() as string).replace("\n"," ").replace("\r"," ");
        let to_query_type:string|undefined = to.attr("query_type");
        let to_query_val:string|undefined = to.attr("query_val");
        let to_text:string = encodeURIComponent(to.val() as string).replace("\n"," ").replace("\r"," ");

        let from_query_arg_components:string[];
        if (from_query_type != undefined && from_query_val != undefined) {
          from_query_arg_components = [
            from_query_type,
            encodeURIComponent(from_query_val),
            from_text
          ];
        } else {
          from_query_arg_components = [from_text]
        };
        let to_query_arg_components:string[];
        if (to_query_type != undefined && to_query_val != undefined) {
          to_query_arg_components = [
            to_query_type,
            encodeURIComponent(to_query_val),
            to_text
          ];
        } else {
          to_query_arg_components = [to_text]
        };

        let dist_unit:string = "mi";


        const query_args = encodeURI(`?stops=${from_query_arg_components.join()}|${to_query_arg_components.join()}&driveDist=${driveDist}&unit=${dist_unit}&submit=true`);

        window.location.href = `/tripPlanner${query_args}`;
      });
});

